module.exports = __webpack_public_path__ + "img/pic.71de2fed.png";